import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Spin } from 'antd';
import { AppDispatch, RootState } from '../../redux/store/store';
import { fetchEmpresas } from '../../redux/actions/empresas/Empresas';
import { debounce } from 'lodash';

interface EmpresasSelectProps {
  onChange: (value: string, empresa: any) => void;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const EmpresasSelect: React.FC<EmpresasSelectProps> = ({
  onChange,
  value,
  placeholder = "Seleccione una empresa",
  disabled = false,
  className,
  style
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { empresas, loading } = useSelector((state: RootState) => state.empresas);
  const [options, setOptions] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    dispatch(fetchEmpresas(1, 10));
  }, []);

  useEffect(() => {
    if (empresas && empresas.length > 0) {
      const empresaOptions = empresas.map(empresa => ({
        value: empresa.id ? empresa.id.toString() : '',
        label: empresa.nombre || '',
        empresa: empresa
      }));

      if (!searchValue) {
        setOptions(empresaOptions.slice(0, 5));
      } else {
        setOptions(empresaOptions);
      }
    } else {
      setOptions([]);
    }
  }, [empresas, searchValue]);

  const debouncedSearch = debounce((value: string) => {
    setSearchValue(value);
    if (value) {
      dispatch(fetchEmpresas(1, 10, value));
    }
  }, 500);

  const handleSearch = (value: string) => {
    debouncedSearch(value);
  };

  const handleChange = (value: string, option: any) => {
    if (value && option) {
      onChange(value, option.empresa || null);
    } else {
      onChange('', null);
    }
    setSearchValue('');
  };

  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      onSearch={handleSearch}
      disabled={disabled}
      loading={loading}
      className={className}
      style={style || { width: '100%' }}
      options={options}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : null}
      defaultActiveFirstOption={false}
      showArrow={true}
    />
  );
};

export default EmpresasSelect;